import React from "react";

import { Props } from "./types";
import { Project } from "./project";
import styles from "./styles.scss";

function Loader(_: Props) {
  return (
    <ul className={styles.projectsList}>
      <li className={styles.item}>
        <Project />
      </li>
      <li className={styles.item}>
        <Project />
      </li>
      <li className={styles.item}>
        <Project />
      </li>
    </ul>
  );
}

export { Loader };
